function computeAge(dateString: string): number {
  const birthday = +new Date(dateString);
  return ~~((Date.now() - birthday) / 31557600000);
}

export default computeAge;
